import { render } from "./EapAssignments.vue?vue&type=template&id=87d880ce&scoped=true"
import script from "./EapAssignments.vue?vue&type=script&lang=js"
export * from "./EapAssignments.vue?vue&type=script&lang=js"

import "./EapAssignments.vue?vue&type=style&index=0&id=87d880ce&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87d880ce"]])

export default __exports__